import { IconRefresh, IconX } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { postApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import IconButton from '../../components/Buttons/IconButton';
import DateRange from '../../components/DateRange/DateRange';
import RequestPlan from '../../components/Plan/RequestPlan';
import StatsCard from "../../components/StatsCard/StatsCard";
import Layout from '../../layout/Layout';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { accessKeys } from '../../statics/accessKeys';
import { PROFILE, SELECTED_META_ACCOUNT } from '../../statics/localStorage';
import { accessCheck } from '../../utils/accessCheck';
import { dateIntoYYYY_MM_DD } from '../../utils/dateTimeConverter';
import AdSetTab from './Components/AdSetTab';
import AdsTab from './Components/AdsTab';
import CampaignsTab from './Components/CampaignsTab';
import MetaAccountsModal from './Components/MetaAccountsModal';
import PlatformGraph from './Components/PlatformGraph';

const MetaAds = () => {
    const profileData = PROFILE();
    const [date, setDate] = useState({ startDate: '', endDate: '' });
    const [cardData, setCardData] = useState(null);
    const [selectedTab, setSelectedTab] = useState(1);

    const [selectedCampaign, setSelectedCampaign] = useState(null);
    const [selectedAdSet, setSelectedAdSet] = useState(null);
    const [selectedMetaAccount, setSelectedMetaAccount] = useState(SELECTED_META_ACCOUNT())

    async function getCardsData() {
        loadingShow();
        let postData = {
            metaAdsAccountId: selectedMetaAccount?.metaAdsAccountId
        }
        if (date?.startDate) {
            postData.startDate = dateIntoYYYY_MM_DD(date.startDate);
            postData.endDate = dateIntoYYYY_MM_DD(date.endDate);
        }
        let url = `${urlApi.getMetaAdCards}`;
        let resp = await postApi(postData, url);
        loadingHide();
        if (resp.responseCode === 200) {
            setCardData(resp.data);
        } else {
            setCardData(null);
        }
    }

    useEffect(() => {
        if (accessCheck(accessKeys?.viewMetaAnalytics) && profileData?.planRequestStatus == 3) {
            getCardsData();
        }
    }, [date, selectedMetaAccount]);

    function onDateChange(p) {
        let newDate = { startDate: p.startDate._d, endDate: p.endDate._d }
        // setActivePage(1);
        setDate(newDate)
    }

    async function syncAdsCampaign() {
        if (!selectedMetaAccount?.metaAdsAccountId) {
            toast.error("Please select an Meta account from the Accounts Popup.");
            return
        }
        loadingShow();
        let postData = {
            "metaAdsAccountId": selectedMetaAccount?.metaAdsAccountId
        }
        let url = `${urlApi.syncMetaAdsCampaign}`;
        let resp = await postApi(postData, url);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            setSelectedTab(1);
            setSelectedCampaign(null);
            setSelectedAdSet(null);
            setDate({ startDate: '', endDate: '' })
        } else {
            toast.error(resp.message);
        }
    }

    const handleClearAdSet = (e) => {
        e.stopPropagation();
        setSelectedCampaign(null);
        setSelectedAdSet(null);
    }

    if (profileData?.planRequestStatus != 3) {
        return (
            <Layout>
                <RequestPlan profileData={profileData} />
            </Layout>
        )
    }

    return (
        <Layout>

            <div className='flex mb-3 gap-3 flex-wrap items-center'>
                <div className='px-2'>
                    <div className='flex gap-2 mb-1'>
                        <p className='text-[17px] font-bold mb-0 text-[var(--grey)]'>Meta Ads</p>
                        <MetaAccountsModal setSelectedMetaAccount={setSelectedMetaAccount} />
                    </div>
                    <p className='text-sm'>[ {selectedMetaAccount?.accountName} {selectedMetaAccount?.accountName && "-"} {selectedMetaAccount?.metaAdsAccountId} ]</p>
                </div>
                <DateRange onApplyClick={(date) => onDateChange(date)} date={date} cssClass={'ms-auto'} />

                {accessCheck(accessKeys?.syncMetaAnalytics) && <IconButton text={"Sync Ads"} icon={<IconRefresh size={20} />} onClickFunction={() => syncAdsCampaign()} />}
            </div>

            <div className="mb-3">
                <div className="grid grid-cols-1 md:grid-cols-6 gap-3">
                    <div className="col-span-1 md:col-span-2">
                        <StatsCard title={"Total Amount Invested"} value={cardData?.totalInvestment?.toFixed(2) || 0} />
                    </div>
                    <div className="col-span-1">
                        <StatsCard title={"Impressions"} value={cardData?.totalImpression || 0} />
                    </div>
                    <div className="col-span-1">
                        <StatsCard title={"Clicks"} value={cardData?.totalClicks || 0} />
                    </div>
                    <div className="col-span-1">
                        <StatsCard title={"Installations"} value={cardData?.totalInstalls || 0} />
                    </div>
                    <div className="col-span-1">
                        <StatsCard title={"Registrations"} value={cardData?.totalRegistrations || 0} />
                    </div>
                </div>
            </div>

            <div className="mb-3">
                <PlatformGraph date={date} selectedMetaAccount={selectedMetaAccount} />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-3">
                <div className="col-span-1">
                    <StatsCard title={"Reach"} value={cardData?.totalReach || 0} />
                </div>
                <div className="col-span-1">
                    <StatsCard title={"Cost/Installation"} value={cardData?.costPerInstall || 0} />
                </div>
                <div className="col-span-1">
                    <StatsCard title={"Cost/Registration"} value={cardData?.costPerRegistration || 0} />
                </div>
            </div>

            <div className="flex items-center flex-wrap justify-center gap-3 px-2 py-1 bg-white rounded-lg max-w-fit mx-auto mb-3">
                <button onClick={() => { setSelectedTab(1) }} className={`${selectedTab == 1 ? '!bg-primary text-white' : 'bg-transparent'} text-sm font-semibold px-5 py-1 rounded-lg`} >Campaigns</button>

                <button onClick={() => { setSelectedTab(2) }} className={`${selectedTab == 2 ? '!bg-primary text-white' : 'bg-transparent'} flex items-center gap-2 text-sm font-semibold px-5 py-1 rounded-lg`}>Ad Sets
                    {selectedCampaign && <p className={`bg-primary text-white h-5 flex px-2 items-center justify-center text-[10px] rounded-full mb-0`} >1 Selected
                        <button className='border-1 border-white rounded-full ms-2' onClick={handleClearAdSet}><IconX size={14} /></button>
                    </p>}
                </button>

                <button onClick={() => { setSelectedTab(3) }} className={`${selectedTab == 3 ? '!bg-primary text-white' : 'bg-transparent'} flex items-center gap-2 text-sm font-semibold px-5 py-1 rounded-lg`}>Ads
                    {selectedAdSet && <p className={`bg-primary text-white h-5 flex px-2 items-center justify-center text-xs rounded-full mb-0`} >1 Selected
                        <button className='border-1 border-white rounded-full ms-2' onClick={handleClearAdSet}><IconX size={14} /></button>
                    </p>}
                </button>
            </div>

            {selectedTab === 1 && <CampaignsTab date={date} selectedCampaign={selectedCampaign} setSelectedCampaign={setSelectedCampaign} setSelectedTab={setSelectedTab} selectedMetaAccount={selectedMetaAccount} />}
            {selectedTab === 2 && <AdSetTab date={date} selectedCampaign={selectedCampaign} setSelectedAdSet={setSelectedAdSet} setSelectedTab={setSelectedTab} selectedAdSet={selectedAdSet} selectedMetaAccount={selectedMetaAccount} />}
            {selectedTab === 3 && <AdsTab date={date} selectedAdSet={selectedAdSet} selectedMetaAccount={selectedMetaAccount} />}

        </Layout>
    )
}

export default MetaAds